module.exports = __webpack_public_path__ + "static/media/Darcy Mehta Headshot_1684265556509.1420e0cd.jpeg";